import React, { useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  InputLabel,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { InputPropType } from "../../interface/input";

import { labelSty } from "./styles-input";


//  const useStyles = makeStyles((theme) => ({
//   customInput: {
//     "& .MuiFormControl-root": {
//       backgroundColor: "#fff", // Replace with your desired color
//     },
//     "& .MuiOutlinedInput-root": {
//       backgroundColor: "#fff",
//       borderRadius: "8px", // Adjust this value as needed
//       "& fieldset": {
//         border: "none",
//       },
//     },
//     "& .MuiInputBase-input": {
//       fontFamily: '"Lexend", sans-serif', // Replace with your desired font
//     },

//     iconButton: {
//       padding: "4px", // Adjust padding as needed
//     },
//     icon: {
//       fontSize: "18px", // Adjust size as needed
//       color: "#757575", // Adjust color as needed
//     },
//   },
// }));
export const InputCustomPassword = ({
  onchange,
  value,
  label,
  placeholder,
  styles,
}: InputPropType) => {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  // const classes = useStyles();
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Stack
      sx={{
        marginBottom: 3,
      }}
    >
      <InputLabel sx={labelSty}>{label}</InputLabel>
      <TextField
        // className={classes.customInput}
        onChange={onchange}
        value={value}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePassword}>
                {showPassword ? (
                  <VisibilityOutlinedIcon />
                ) : (
                  <VisibilityOffOutlinedIcon />
                )}
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            style: {
              paddingLeft: "8px",
              fontSize: "13px",
              fontFamily: "Lexend",
              fontWeight: 400,
              borderRadius: "8px",
              backgroundColor: "#FFF",
              color: theme.palette.customOne.main,
              ...styles,
            },
          },
        }}
      />
    </Stack>
  );
};
